const config = {
  method: "GET",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-api-key": "e17fd67932e135afbe858ad03882d826feaf0124e972d08d",
  },
};
export default config;
